import { SVGProps } from 'react';

export default function SendIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.8409 2.33228C23.1177 1.54146 22.3575 0.781283 21.5667 1.05807L1.66982 8.02197C0.878045 8.29909 0.758809 9.36922 1.47017 9.81382L8.36358 14.1222L15.2284 7.25736C15.6188 6.86699 16.2517 6.86699 16.6421 7.25735C17.0324 7.64772 17.0324 8.28063 16.6421 8.67099L9.7771 15.5359L14.0851 22.4288C14.5297 23.1401 15.5999 23.0209 15.877 22.2291L22.8409 2.33228Z" fill={fill} />
    </svg>
  );
}
